import React from 'react';
import { FaPhoneAlt } from 'react-icons/fa';
import { CONTACT_INFO } from '../config/constants';

export default function NavbarEmergency() {

  const phone = CONTACT_INFO.mainPhone;
  const phone2 = CONTACT_INFO.phone2;
  const phone3 = CONTACT_INFO.phone3;
  const phone4 = CONTACT_INFO.phone4;

  return (
    <nav>
      {/* Fixed Emergency Number Bar */}
      {/* <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-tr from-sky-300 to-blue-400 opacity-30 rounded-full blur-3xl -translate-x-1/3 -translate-y-1/3 pointer-events-none"></div> */}
      <div className=" w-full bg-gradient-to-r from-zinc-50 via-slate-50 via-white to-zinc-50 bg-gradient-animated text-white text-center flex justify-center items-center pt-1 px-2 md:px-0 shadow-sm z-[60]">
      {/* <div className='w-full bg-zinc-50 text-center flex justify-center items-center pt-1 px-2 md:px-0 shadow-sm z-[60]'> */}
        <FaPhoneAlt className="text-red-600 text-lg md:text-xl mr-2" />
        <div className="flex flex-wrap justify-center items-center gap-3 md:gap-6 text-base md:text-lg  text-sky-600 tracking-wide">
          <span className=" text-red-700">Call Us: </span>
          <a href={`tel:${phone}`} className="hover:text-red-700 transition">+91 {phone}</a>
          <span className="hidden md:inline text-red-700">/</span>
          <a href={`tel:${phone2}`} className="hover:text-red-700 transition">{phone2}</a>
          <span className="hidden md:inline text-red-700">/</span>
          <a href={`tel:${phone3}`} className="hover:text-red-700 transition">{phone3}</a>
          <span className="hidden md:inline text-red-700">/</span>
          <a href={`tel:${phone4}`} className="hover:text-red-700 transition">{phone4}</a>
        </div>
      </div>
    </nav>
  );
}

